// #region Imports
import { ReactNode } from "react";
import { Box } from "@mui/material";
import Navbar from "../organisms/Navbar/navbar.organism";
// #endregion

// #region Interfaces & Types & Enums
interface RootLayoutProps {
    children: ReactNode;
}
// #endregion

// #region Component
/**
 * AppRootLayout component that provides the main application layout structure
 * Uses MUI Box components for consistent Material Design styling and responsive layout
 * Includes Navbar component at the top for main navigation
 *
 * @param props - Component props
 * @param props.children - The main content to render in the layout
 */
function AppRootLayout(props: RootLayoutProps) {
    const { children } = props;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Navbar />
            <Box component="main" sx={{ flexGrow: 1 }}>
                {children}
            </Box>
        </Box>
    );
}
// #endregion

// #region Exports
export default AppRootLayout;
// #endregion
